<div class="dialog">
  <h1>Create CDN-Link</h1>

  <div class="input-label">Size</div>
  <form [formGroup]="sizeForm">
    <div class="field-row">
      <app-context-menu [options]="{ width: '260px', noSpacing: true }" #menu>
        <button
          appButton
          name="size"
          location="create-cdn-link-dialog"
          [hasIcon]="true"
          shape="small"
          fullWidth="true"
          height="3"
          contextButton
        >
          <div class="fake-select-content">
            <div>{{ selectedLongEdge?.name || 'Custom' }}</div>
          </div>
          <app-svg src="/assets/icons/chevron-down.svg" color="grey-50"></app-svg>
        </button>

        <div contextContent class="button-menu">
          @for (size of presetSizes; track size) {
            <app-button-menu-item
              [name]="size.name"
              location="create-cdn-link-dialog"
              [fullWidth]="true"
              (onClick)="setLongEdge(size); menu.close()"
              >{{ size.name }}
              @if (size.longEdge) {
                ({{ size.longEdge }}px)
              }
            </app-button-menu-item>
          }

          <div class="divider"></div>
          <app-button-menu-item
            name="custom"
            location="create-cdn-link-dialog"
            [fullWidth]="true"
            (onClick)="setLongEdge(undefined); menu.close()"
            >Custom
          </app-button-menu-item>
        </div>
      </app-context-menu>

      <app-input-field [control]="sizeForm.controls.width" class="headless no-post-spacing" [noLabel]="true">
        <input type="number" formControlName="width" placeholder="Width" (input)="autoCalcHeight()" />
        <div *appInputPost class="px">px</div>
      </app-input-field>

      <app-input-field [control]="sizeForm.controls.height" class="headless no-post-spacing" [noLabel]="true">
        <input type="number" formControlName="height" placeholder="Height" (input)="autoCalcWidth()" />
        <div *appInputPost class="px">px</div>
      </app-input-field>
    </div>
  </form>

  <div class="input-label">Link</div>
  <app-input-field
    [noLabel]="true"
    [noLabelExtraSpacing]="true"
    class="gallery-path-field"
    [class.disabled]="
      gallery.public_access === 'no_access' || (gallery.tenant || activeTenant())['block_public_link_access']
    "
  >
    <div fake-input class="fake-input-path no-hover">
      <span>{{ cdnLink || 'Loading...' }}</span>
    </div>
    <div *appInputPost class="copy-button">
      <button
        appButton
        type="button"
        name="copy-link"
        location="create-cdn-link-dialog"
        height="1"
        spacing="3"
        shape="round"
        color="primary"
        [share]="cdnLink"
        (onCopied)="onLinkCopied()"
        [attr.test-share-content]="cdnLink"
      >
        @if (!canShare) {
          <span>Copy</span>
        } @else {
          <span>Share</span>
        }
      </button>
    </div>
  </app-input-field>
</div>
